var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('auction-form',{attrs:{"loading":_vm.loading,"auctionData":_vm.auction,"formErrors":_vm.formErrors},on:{"auctionSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }